import { actionTypes, change as reduxChange } from 'redux-form';

import { getNoOfSelectedBoardBasesByGuestType, getNoOfSelectedGuestsByGuestType } from "../apiHelpers";

export default store => next => action => {
	// let the action go to the reducers
	next(action);

	if (action.type !== actionTypes.CHANGE || !action.meta || action.meta.form !== 'bookingForm') return;

	const fieldName = action.meta.field.substring(0, action.meta.field.indexOf('['));

	// Zajímá nás pouze změna počtu hostu nebo množství stravy
	if (fieldName !== 'boardBase' && fieldName !== 'rooms') return;

	// Množství stravy jsme snížili na nula
	if (fieldName === 'boardBase' && action.payload === 0) return;

	const formValues = store.getState().form.bookingForm.values;

	// Formulář ještě není inicializovaný, nebo se u stravy nedá vybrat množství
	if (typeof formValues.boardBase !== 'object') return;

	const matches = action.meta.field.match(fieldName === 'boardBase' ? /boardBase\[(\d+)]\[(\d+)]/ : /rooms\[\d+]\[\d+]\[guestTypes]\[(\d+)]/);
	if (matches) {
		const fieldBoardBase = fieldName === 'boardBase' ? matches[1] : null;
		const fieldGuestType = fieldName === 'boardBase' ? matches[2] : matches[1];

		if (getNoOfSelectedBoardBasesByGuestType(formValues, fieldGuestType) > getNoOfSelectedGuestsByGuestType(formValues, fieldGuestType)) {
			for (let boardBase of Object.keys(formValues.boardBase)) {
				if (boardBase !== fieldBoardBase && formValues.boardBase[boardBase][fieldGuestType] > 0) {
					store.dispatch(reduxChange(action.meta.form, `boardBase[${boardBase}][${fieldGuestType}]`, formValues.boardBase[boardBase][fieldGuestType] - 1));
					break;
				}
			}
		}
	}
};


// WEBPACK FOOTER //
// ./src/store/boardBasesMiddleware.js